import React, { useState } from 'react';

const PAGE_SIZE = 3;

const OpenCoreSection = () => {
  const cores = [
    {
      title: '[rust_markdown_transformer]',
      desc: 'Rust 기반 문서 Markdown 변환 라이브러리',
      detail: 'docx / pptx / xlsx / hwpx / pdf / html',
      link: 'https://github.com/arabangoo/rust_markdown_transformer'
    },
    {
      title: '[rust_ocr_transformer]',
      desc: 'Rust 기반 통합 비전 추론 및 처리 프레임워크',
      detail: '디코드 → 전처리 → 신경망 모델 추론 → 후처리 → 구조화 출력',
      link: 'https://github.com/arabangoo/rust_ocr_transformer'
    },
    {
      title: '[rust_scholar_transformer]',
      desc: 'Rust 기반 실시간 멀티소스 검색 코어 엔진',
      detail: 'arXiv / 뉴스 / 블로그 / 유튜브 / 웹',
      link: 'https://github.com/arabangoo/rust_scholar_transformer'
    },
    {
      title: '[rust_ai_serving_engine]',
      desc: 'Rust 기반 로컬 LLM 서빙 엔진',
      detail: 'CPU 오프라인 환경 로컬 LLM 실행',
      link: 'https://github.com/arabangoo/rust_ai_serving_engine'
    },
    {
      title: '[rust_pii_transformer]',
      desc: 'Rust 기반 한국어 개인정보 탐지 및 마스킹',
      detail: '주민등록번호 / 외국인등록번호 / 카드번호 / 계좌번호 등 10종',
      link: 'https://github.com/arabangoo/rust_pii_transformer'
    },
    {
      title: '[rust_multi_ranking_engine]',
      desc: 'Rust 기반 다기준 랭킹 및 후보 선택 엔진',
      detail: '점수 융합 → 제약 적용 → 상위 K 선택 → 근거 기록',
      link: 'https://github.com/arabangoo/rust_multi_ranking_engine'
    },
  ];

  const [page, setPage] = useState(0);

  // 카드 순서는 그대로 둔다. 네 번째 카드가 2페이지의 첫 카드가 되는 방식이라
  // 새 항목을 배열 끝에 더하면 뒷페이지가 자연스럽게 늘어난다.
  const pageCount = Math.ceil(cores.length / PAGE_SIZE);
  const current = Math.min(page, pageCount - 1);
  const shown = cores.slice(current * PAGE_SIZE, current * PAGE_SIZE + PAGE_SIZE);

  return (
    <section className="service-section">
      <h2>Open Core</h2>
      <div className="ai-links">
        {shown.map((core) => (
          <div key={core.link} className="ai-service">
            <h3>{core.title}</h3>
            <p>{core.desc}</p>
            <p>{core.detail}</p>
            <a href={core.link} target="_blank" rel="noopener noreferrer">
              {core.link}
            </a>
          </div>
        ))}
      </div>

      {pageCount > 1 && (
        <nav className="pager" aria-label="Open Core 페이지">
          <button
            type="button"
            className="pager-arrow"
            onClick={() => setPage(current - 1)}
            disabled={current === 0}
            aria-label="이전 페이지"
          >
            ‹
          </button>
          {Array.from({ length: pageCount }, (unused, i) => (
            <button
              key={i}
              type="button"
              className={`pager-num ${i === current ? 'on' : ''}`}
              onClick={() => setPage(i)}
              aria-current={i === current ? 'page' : undefined}
            >
              {i + 1}
            </button>
          ))}
          <button
            type="button"
            className="pager-arrow"
            onClick={() => setPage(current + 1)}
            disabled={current === pageCount - 1}
            aria-label="다음 페이지"
          >
            ›
          </button>
        </nav>
      )}
    </section>
  );
};

export default OpenCoreSection;
